<template>
  <div>
    <div class="d-inline-flex mb-4">
      <div class="form-check mr-3" v-if="movementFields && movementFields.length">
        <input
          class="check form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">Movement</h4>
      <div class="d-flex align-items-center">
        <span class="cursor-pointer" @click="addMovement()">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
          />
        </span>
      </div>
       <span
          v-if="isSelected"
          class="cursor-pointer ml-3"
          @click="deleteAllMovements()"
        >
          <i class="fa fa-trash"></i>
      </span>
    </div>
    <div  class="mb-3">
      <div v-for="(item, index) in movementFields" :key="index">
        <div
          class="fields-wrapper is-divider is-multi-node mb-6"
        >
          <div class="form-check select-single">
            <input
              class="form-check-input"
              type="checkbox"
              @change="checkSingleSelect"
              v-model="item.movement.selectSingle"
            />
          </div>
          <div class="action-buttons">
             <span
              class="action-item "
              @click="copyMovement(index, item)"
            >
              <i class="fa fa-copy"></i>
            </span>
            <span 
              class="action-item" 
              @click="removeMovement(index)"
            >
              <i class="fa fa-trash"></i>
            </span>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="row form-group align-items-center">
                <label class="col-sm-5 col-form-label">
                  Path Type
                </label>
                <div class="col-sm-7">
                  <select
                    class="custom-select"
                    v-model="item.movement.pathType"
                    @change="pathTypeChanged(index)"
                  >
                    <option value="Linear">Linear</option>
                    <option value="CatmullRom">CatmullRom</option>
                    <option value="CubicBezier">CubicBezier</option>
                  </select>
                </div>
              </div>
              <div class="row form-group align-items-center">
                <label class="col-sm-5 col-form-label">
                  Orientation Type
                </label>
                <div class="col-sm-7">
                  <select
                    class="custom-select"
                    v-model="item.movement.orientationType"
                  >
                    <option value="LookAhead">Look Ahead</option>
                    <option value="LookAtTarget">Look At Target</option>
                    <option value="LookAtPosition">Look at Position</option>
                  </select>
                </div>
              </div>
              <div
                class="row form-group align-items-center"
                v-if="item.movement.orientationType === 'LookAtTarget'"
              >
                <label class="col-sm-5 col-form-label">
                  Target
                </label>
                <div class="col-sm-7">
                  <select
                    class="custom-select"
                    v-model="item.movement.entityOrientation.lookAtTarget"
                  >
                    <option
                      :value="target.objectId"
                      v-for="target in targets"
                      :key="target.objectId"
                      >{{ target.name }}</option
                    >
                  </select>
                </div>
              </div>
              <div
                class="row form-group align-items-center"
                v-if="item.movement.orientationType === 'LookAtPosition'"
              >
                <label class="col-sm-5 col-form-label">
                  Position
                </label>
                <div class="col-sm-7">
                  <div class="d-flex align-items-center">
                    <span class="p-2">x</span>
                    <input
                      type="text"
                      class="form-control"
                      id="destination_position_x"
                      v-model="
                        item.movement.entityOrientation.lookAtPosition[0]
                      "
                    />
                    <span class="p-2">y</span>
                    <input
                      type="text"
                      class="form-control"
                      id="destination_position_y"
                      v-model="
                        item.movement.entityOrientation.lookAtPosition[1]
                      "
                    />
                    <span class="p-2">z</span>
                    <input
                      type="text"
                      class="form-control"
                      id="destination_position_z"
                      v-model="
                        item.movement.entityOrientation.lookAtPosition[2]
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="row form-group align-items-center">
                <label class="col-sm-5 col-form-label">
                  Total duration (sec)
                </label>
                <div class="col-sm-7">
                  <input
                    type="number"
                    :value="duration(index)"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>
              <div class="row form-group align-items-center">
                <div class="col-sm-5 form-check">
                  <input
                    type="checkbox"
                    id="loopCount"
                    v-model="item.movement.loopCount"
                  />
                  <label class="col-form-label ml-2">
                    Loop
                  </label>
                </div>
                <div class="col-sm-5 form-check">
                  <input
                    type="checkbox"
                    id="loopCount"
                    v-model="item.movement.isSpeedbased"
                  />
                  <label class="col-form-label ml-2">
                    Is speed based
                  </label>
                </div>
              </div>
              <div class="row form-group align-items-center"></div>
              <div class="row form-group align-items-center">
                <label class="col-sm-5 col-form-label">
                  Rotation speed
                </label>
                <div class="col-sm-7">
                  <input
                    type="number"
                    v-model="item.movement.lookAtValue"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="d-inline-flex mb-3">
                <h4 class="mb-0">Way Points</h4>
                <div class="d-flex align-items-center ml-4 mt-0">
                  <span class="cursor-pointer" @click="addNewWayPoint(index)">
                    <img
                      src="~@/assets/addplus_icon.svg"
                      width="20"
                      class="heading-icon"
                    />
                  </span>
                </div>
              </div>
              <div
                class="fields-wrapper is-multi-node mb-6"
                v-for="(point, elem) in item.movement.waypoints"
                :key="elem"
              >
                <div class="action-buttons">
                  <span class="action-item " @click="copyWayPoint(index, point)">
                    <i class="fa fa-copy"></i>
                  </span>
                  <span
                    v-if="
                      (item.movement.pathType == 'CubicBezier' && item.movement.waypoints.length > 3)
                      || (item.movement.pathType != 'CubicBezier' && item.movement.waypoints.length > 1)
                    "
                    class="action-item"
                    @click="deleteWayPoint(index, elem)"
                  >
                    <i class="fa fa-trash"></i>
                  </span>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Start Time (sec)
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      class="form-control"
                      v-model="point.startTime"
                      @change="startTimeChanged(index, elem)"

                    />
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    End Time (sec)
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      class="form-control"
                      v-model="point.endTime"
                      @change="endTimeChanged(index, elem)"
                    />
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Duration (sec)
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      class="form-control"
                      v-model="point.duration"
                      readonly
                    />
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Point
                  </label>
                  <div class="col-sm-7">
                    <div class="d-flex align-items-center">
                      <span class="p-2">x</span>
                      <input
                        type="number"
                        step="0.1"
                        class="form-control"
                        id="destination_position_x"
                        v-model="point.point[0]"
                      />
                      <span class="p-2">y</span>
                      <input
                        type="number"
                        step="0.1"
                        class="form-control"
                        id="destination_position_y"
                        v-model="point.point[1]"
                      />
                      <span class="p-2">z</span>
                      <input
                        type="number"
                        step="0.1"
                        class="form-control"
                        id="destination_position_z"
                        v-model="point.point[2]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uuid } from 'vue-uuid'
import { db } from '../../../../../firebaseDB'
import { mapState } from 'vuex'
export default {
  components: {},
  data () {
    return {
      movement: {},
      targets: [],
      objectId: '',
      activeModel: {},
      selectAll: false,
      movementFields: [],
      isSelected:false,
    }
  },
  created () {},
  methods: {
    saveToDB () {
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
      tRef.once('value').then(async snapshot => {
        let json = snapshot.val().json
        let storyData = snapshot.val();
        let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
        .filter(n => n.key !== 'Start')
        .filter(n => n.category == 'Scene');
        let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
        let object3DElements = []
        for (const snapshotkey in json.mainStory.nodes[selectedNodePosition].nodeElements) {
          if (
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty(
              'character'
            ) &&
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
              .objectId == this.objectId
          ) {
            for (const innerKey in json.mainStory.nodes[selectedNodePosition].nodeElements[
              snapshotkey
            ].character.object3DElements) {
              if (
                json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
                  .object3DElements[innerKey].elementType === 'Movement'
              ) {
                delete json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey]
                  .character.object3DElements[innerKey]
              } else {
                object3DElements.push(
                  json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character
                    .object3DElements[innerKey]
                )
              }
            }
            _this.movementFields.forEach((value, key) => {
              if (value.movement.orientationType == 'LookAhead') {
                value.movement.entityOrientation.lookAhead = true
              }
              object3DElements.push({
                elementType: value.elementType,
                movement: {...value.movement},
              })
            })
            json.mainStory.nodes[selectedNodePosition].nodeElements[
              snapshotkey
            ].character.object3DElements = object3DElements
            let updates = {}
            updates[localStorage.getItem('storyId') + `/json`] = json
            db.ref('stories')
              .update(updates)
              .then(snapshot => {
                _this.showSuccessToast()
              })
              .catch(e => {
                _this.showErrorToast()
              })
            this.$parent.activeComponent = 'movement'
          }
        }
      })
    },
    showSuccessToast () {
      this.$toast('Movement inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Movement inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    deleteWayPoint (index, point) {
      if (index > -1) {
        if (
          this.movementFields[index].hasOwnProperty('movement') &&
          this.movementFields[index].movement.startPointId ==
            this.movementFields[index].movement.waypoints[point].id
        ) {
          this.movementFields[index].movement.startPointId = this.movementFields[index].movement.waypoints[
            point
          ].nextPointId
        }
        this.movementFields[index].hasOwnProperty('movement') &&
          this.movementFields[index].movement.waypoints.forEach((element, i) => {
            if (
              element.nextPointId == this.movementFields[index].movement.waypoints[index].id
            ) {
              this.movementFields[index].movement.waypoints[
                i
              ].nextPointId = this.movementFields[index].movement.waypoints[
                point
              ].nextPointId
            }
          })
        this.$root.$emit('removeWaypoint', this.movementFields[index].movement.id, this.movementFields[index].movement.waypoints[point].id, this.activeModel.objectId)
        this.movementFields[index].movement.waypoints.splice(point, 1);
      }
    },
    copyWayPoint (index, point) {
      if (this.movementFields[index].hasOwnProperty('movement')) {
        const previousIndex = this.movementFields[index].movement.waypoints.length
          ? this.movementFields[index].movement.waypoints.length - 1
          : 0
        this.movementFields[index].movement.waypoints.push({
          id: parseInt(this.movementFields[index].movement.waypoints[previousIndex].id) + 1,
          nextPointId:
            parseInt(this.movementFields[index].movement.waypoints[previousIndex].id) + 2,
          startTime: parseFloat(
            this.movementFields[index].movement.waypoints[previousIndex].endTime
          ).toFixed(2),
          endTime:
            (parseFloat(this.movementFields[index].movement.waypoints[previousIndex].endTime) +
            parseFloat(point.duration)).toFixed(2),
          duration: parseFloat(point.duration),
          point: [point.point[0], point.point[1], point.point[2]]
        })
        this.setTotalDuration(index)
      }
    },
    addNewWayPoint (index) {
      if (this.movementFields[index].hasOwnProperty('movement')) {
        const elem = this.movementFields[index].movement.waypoints.length
        this.movementFields[index].movement.waypoints.push({
          id: parseInt(this.movementFields[index].movement.waypoints[elem - 1].id) + 1,
          nextPointId:
            parseInt(this.movementFields[index].movement.waypoints[elem - 1].id) + 2,
          startTime: parseInt(this.movementFields[index].movement.waypoints[elem - 1].endTime),
          endTime: parseInt(this.movementFields[index].movement.waypoints[elem - 1].endtime) + 2,
          duration: 2,
          point: [0, 0, 0]
        })
      }
    },
    nextElement (time) {
      let duration = 2
      let min = 99999999
      let element = this.movementFields.filter((el) => {
        return (parseFloat(el.movement.waypoints[0].startTime) <= time && parseFloat(el.movement.waypoints[el.movement.waypoints.length - 1].endTime) > time)
      })
      if (element.length) {
        return 0;
      }
      element = this.movementFields.forEach((el) => {
        if (parseFloat(el.movement.waypoints[0].startTime) >= time && parseFloat(el.movement.waypoints[0].startTime) <= min) {
          duration = parseFloat(el.movement.waypoints[0].startTime) - time
          min = parseFloat(el.movement.waypoints[0].startTime)
        }
      })
      return duration;
    },
    addMovement () {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      duration = duration <= 2 ? duration : 2;
      let start = 0
      let end = 0
      if (duration == 2 && this.timeLineCursor >= this.activeModel.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(duration)).toFixed(2)
        duration = parseFloat(duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + 2).toFixed(2) : parseFloat(this.activeModel.startTime) + 2
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeModel.startTime)
        duration = 2
      }
      if (this.activeModel.objectId) {
        this.movementFields.push({
          elementType: 'Movement',
          movement: {
            id: uuid.v1(),
            intId: Math.floor(Date.now() / 1000),
            pathType: 'Linear',
            orientationType: 'LookAhead',
            startPointId: 0,
            loopCount: false,
            duration: 2,
            entityOrientation: {
              lookAhead: true,
              lookAtTarget: '',
              lookAtPosition: [0, 0, 0]
            },
            isSpeedbased: false,
            lookAtValue: 0.01,
            waypoints: [
              {
                id: 0,
                nextPointId: 1,
                startTime: start,
                endTime: end,
                duration: duration,
                point: [0, 0, 0]
              }
            ]
          }
        })
        this.reflext()
      } else {
        this.$toast('Please select a character first to add movement to it !', {
          timeout: 3000,
          type: 'error',
          showCloseButtonOnHover: true
        })
      }
    },
    copyMovement (index, item) {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      let start = 0
      let end = 0
      if (duration >= item.movement.duration && this.timeLineCursor >= this.activeModel.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(item.movement.duration)).toFixed(2)
        duration = parseFloat(item.movement.duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + parseFloat(item.movement.duration)).toFixed(2) : parseFloat(this.activeModel.startTime) + parseFloat(item.movement.duration)
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeModel.startTime)
        duration = parseFloat(item.movement.duration).toFixed(2)
      }
      var waypoints = item.movement.waypoints.map((point, index) => {
        return {
          ...point,
          point: [point.point[0], point.point[1], point.point[2]],
          startTime: !index ? parseFloat(start) : parseFloat(start) + parseFloat(item.movement.waypoints[index - 1].duration),
          endTime: !index ? parseFloat(start) + parseFloat(point.duration) : parseFloat(start) + parseFloat(item.movement.waypoints[index - 1].duration) + parseFloat(point.duration)
          }
      })
      this.movementFields.push({
        elementType: 'Movement',
        movement: {
          id: uuid.v1(),
          intId: Math.floor(Date.now() / 1000),
          pathType: item.movement.pathType,
          orientationType: item.movement.orientationType,
          startPointId: 0,
          loopCount: item.movement.loopCount,
          duration: item.movement.duration,
          entityOrientation: item.movement.entityOrientation,
          isSpeedbased: item.movement.isSpeedbased,
          lookAtValue: item.movement.lookAtValue,
          waypoints: waypoints
        }
      })
      this.reflext()
    },
    reflext () {
      let newChar =
      this.characters &&
      this.characters.map(char =>
        char.objectId === this.objectId
          ? {
            ...char,
            object3DElements: 
            char.object3DElements ? [
              ...char.object3DElements.filter(
              el => !el.hasOwnProperty('movement')
              ),
              ...this.movementFields
            ] :  
            [ ...this.movementFields ]
          }
          : {...char}
      )

      this.$store.dispatch('updateCharacters', newChar)
    },
    getDuration (index) {
      if (this.movement.hasOwnProperty('movement')) {
        let waypoint = this.movement.movement.waypoints[index]
        return waypoint.endTime - waypoint.startTime
      }
    },
    removeMovement (index) {
      let id = this.movementFields[index].movement.id
      if (index > -1) {
        this.movementFields.splice(index, 1)
      }
      this.reflext()
      this.$root.$emit('removeSubnode', id, 'Movement', this.activeModel.objectId)
    },
    endTimeChanged (item, index) {
      let movement = this.movementFields[item].movement
      if (
        movement.waypoints[index].startTime &&
        parseFloat(movement.waypoints[index].startTime) >=
        parseFloat(movement.waypoints[index].endTime)
      ) {
          this.movementFields[item].movement.waypoints[index].endTime =
          parseFloat(movement.waypoints[index].startTime) + 1
      } else if (
        movement.waypoints[index + 1] &&
        movement.waypoints[index + 1].startTime &&
        movement.waypoints[index + 1].startTime < movement.waypoints[index].endTime
      ) {
          this.movementFields[item].movement.waypoints[index].endTime = parseFloat(
          movement.waypoints[index + 1].startTime
        )
      }
      this.setWaypointDuration(item, index)
      this.setTotalDuration(item)
    },
    startTimeChanged (item, index) {
      let movement = this.movementFields[item].movement
      let lastElem = this.movementFields[item - 1] ? this.movementFields[item - 1].movement.waypoints.length - 1 : 0
      if (item && !index && this.movementFields[item - 1] && movement.waypoints[index].startTime < parseFloat(this.movementFields[item - 1].movement.waypoints[lastElem].endTime)) {
        this.movementFields[item].movement.waypoints[index].startTime =
            parseFloat(this.movementFields[item - 1].movement.waypoints[lastElem].endTime)
      } else if (
        movement.waypoints[index].endTime &&
        movement.waypoints[index].startTime > 0 &&
        movement.waypoints[index].startTime >=
        movement.waypoints[index].endTime
      ) {
        this.movementFields[item].movement.waypoints[index].startTime =
          parseFloat(movement.waypoints[index].endTime) - 1
      } else if (
        movement.waypoints[index - 1] &&
        movement.waypoints[index - 1].endTime >
        movement.waypoints[index].startTime
      ) {
        this.movementFields[item].movement.waypoints[index].startTime = parseFloat(
          movement.waypoints[index - 1].endTime
        )
      }
      this.setWaypointDuration(item, index)
      this.setTotalDuration(item)
    },
    setWaypointDuration (item, index) {
      this.movementFields[item].movement.waypoints[index].duration =
        (parseFloat(this.movementFields[item].movement.waypoints[index].endTime) -
        parseFloat(this.movementFields[item].movement.waypoints[index].startTime)).toFixed(2)
    },
    setTotalDuration (item) {
      let lastItem = this.movementFields[item].movement.waypoints.length - 1
      this.movementFields[item].movement.duration =  this.movementFields[item].movement.waypoints[lastItem].endTime - this.movementFields[item].movement.waypoints[0].startTime
    },
    changeSelectedObject () {
      this.movementFields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.objectId =  val.objectId
          this.activeModel = val
          if (val.object3DElements) {
            val.object3DElements.forEach(element => {
              if (element.elementType === 'Movement') {
                this.movementFields.push(element)
              }
            });
          }
        }
      })
    },
    checkSingleSelect () {
      this.movementFields.forEach(value => {
        if (value.movement.selectSingle) {
          this.isSelected = true
        }
      })
    },
    duration (index) {
      let lastItem = this.movementFields[index].movement.waypoints.length - 1
      return (this.movementFields[index].movement.waypoints[lastItem].endTime - this.movementFields[index].movement.waypoints[0].startTime).toFixed(2)
    },
    deleteAllMovements () {
      let newChar =
        this.characters &&
        this.characters.map(char => {
            if (char.objectId === this.objectId) {
              let object3DElements = char.object3DElements.filter(value => {
                return !value.movement
              })
              return { ...char, object3DElements: object3DElements }
            } else {
              return { ...char }
            }
        })
      this.$store.dispatch('updateCharacters', newChar)
      this.selectAll = false
    },
    pathTypeChanged (index) {
      if (this.movementFields[index].movement.pathType == 'CubicBezier') {
        while(this.movementFields[index].movement.waypoints.length < 3) {
          this.addNewWayPoint(index)
        }
      }
    }
  },
  mounted () {
    let found = false
    for (let i = 0; i < this.characters.length; i++) {
      const char = this.characters[i]
      if (char.active) {
        this.objectId = char.objectId
        this.activeModel = char
        found = true
      }
    }
    if (this.activeModel.hasOwnProperty('object3DElements')) {
      this.movementFields = this.activeModel.object3DElements.filter(el => {
        return el.hasOwnProperty('movement')
      })
    }
    //get targets
    let _this = this
    let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
    let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
    tRef.once('value').then(snapshot => {
      let storyData = snapshot.val();
        let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
        .filter(n => n.key !== 'Start')
        .filter(n => n.category == 'Scene');
        let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
      if (storyData && storyData.json.mainStory.nodes[selectedNodePosition].nodeElements) {
        snapshot.val().json.mainStory.nodes[selectedNodePosition].nodeElements.forEach(value => {
          if (value.elementType === 'Character' || value.elementType === 'Object3D') {
            _this.targets.push(value.character ? value.character : value.object3D)
          }
        })
      }
    })
  },
  watch: {
    characters (val) {
      this.changeSelectedObject()
    },
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.movementFields) {
        this.movementFields.forEach(value => {
          value.movement.selectSingle = val
        })
      }
    },
  },
  computed: {
    lastElementEndTime () {
      let max = 0
      this.movementFields.forEach((el) => {
        if (parseFloat(el.movement.waypoints[el.movement.waypoints.length - 1].endTime) >= max) {
          max = parseFloat(el.movement.waypoints[el.movement.waypoints.length - 1].endTime)
        }
      })
      return max;
    },
    ...mapState([
      'characters',
      'timeLineCursor'
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/models/movement.vue